import types from "../actions";


const initialState = {
  src: null,
  playing: false,
  loading: false,
  time: 0
}

export default function (state = initialState, action) {
  switch (action.type) {
    case types.UPDATE_AUDIO_TIME:
      return { ...state, time: action.time, playing: action.time > 0 }
    case types.PLAY_AUDIO:
      if (action.src && action.src !== state.src) {
        return {
          ...state,
          loading: true,
          src: action.src
        }
      }
      return { ...state, playing: true }
    case types.PAUSE_AUDIO:
      return { ...state, playing: false }
    case types.SET_LOADING:
      return { ...state, loading: action.state }
    default:
      return state;
  }
}
